"use client";

import { c as _c } from "react/compiler-runtime";
import { RadioGroup as HeroRadioGroup } from "@heroui/react";
import { cn } from "../../lib/utils";
import styles from "./RadioGroup.module.css";
export const RadioGroup = t0 => {
  const $ = _c(9);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  const {
    color: t1
  } = props;
  const color = t1 === undefined ? "default" : t1;
  let t2;
  if ($[3] !== className) {
    t2 = cn(styles.radioGroup, className);
    $[3] = className;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== color || $[6] !== props || $[7] !== t2) {
    t3 = <HeroRadioGroup className={t2} data-color={color} {...props} />;
    $[5] = color;
    $[6] = props;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};